import './App.css';
import 'handsontable/dist/handsontable.full.min.css';
import Navbar from './components/Navbar';
import React from "react";
import {
  Route,
  Routes,
} from "react-router-dom";

import Home from './components/Home'
import Highlow from './components/Highlow';
import HighlowLogin from './components/HighlowLogin';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Homelogged from './components/Homelogged'

function App() {

  return (
      <div>
        <Navbar/>
        <Routes>
          <Route exact path='/' element={ 
            <Home/>
          
          }/>
          <Route exact path='/52highlow' element={
            <Highlow/>
          }/>
          <Route exact path='/52highlowlogin' element={<ProtectedRoute>
            <HighlowLogin/>
          </ProtectedRoute>}/>
          <Route exact path='/login' element={<Login/>}/>
          <Route exact path='/Homelogged' element={<ProtectedRoute>
            <Homelogged/>
          </ProtectedRoute>}/>
          
          {/* <Route exact path='/52highlowlogin' element={
            <HighlowLogin/>
          }/> */}
         </Routes>
      </div>

  );
}

export default App;
